import { KrDetailSkeleton } from '@workboard/ui-okr';
import { styled } from '@mui/material';
import { KeyResultCardList } from './KeyResultCardList';
  

const KrWrapper = styled('div')`
  margin-right: 8px;
`;
  
export const LazyKrLoader = ({
  loading,
  krs,
  }) => {
  if (loading) {
    return <KrDetailSkeleton />
  }

  return (
    <KrWrapper>
      <KeyResultCardList data={krs} />
    </KrWrapper>
  );
};
